<template>
  <div>
    <el-tabs v-model="currentActive" class="tabs-area" :type="tabsCard" @tab-click="handleTabClick">
      <el-tab-pane v-for="item in paneList" :key="item.name" :label="item.label" :name="item.name">
        <div slot="label" class="badge-slot">
          <el-badge :value="paneList.badgeNum" :max="99" class="item" :hidden="isHiddenBadge">
            <span size="small" style="padding: 0 20px">{{ item.label }}</span>
          </el-badge>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: 'ETabs',

  components: {},
  props: {
    paneList: {
      type: Array,
      default() {
        return [];
      },
    },
    active: {
      type: [Number, String],
      default: 0,
    },
    isHiddenBadge: {
      type: Boolean,
      default: true,
    },
    tabsCard: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      currentActive: this.active,
    };
  },
  created() {},
  methods: {
    handleTabClick(val) {
      console.log('handleTabClick', this.currentActive, val);
      this.$emit('handleTabClick', this.currentActive, val);
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  position: relative;
  background: rgba(244, 247, 255, 1);
  // border-top: 2px solid rgba(37, 135, 255, 1);
  &:before {
    content: '';
    width: 100%;
    height: 2px;
    background: rgba(37, 135, 255, 1);
    position: absolute;
    left: 0;
  }
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border-radius: 0;
}
</style>
